import {
  Alert,
  Button,
  FormField,
  Link,
  PasswordField,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import { Divider } from '@mui/material';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import useSupportChat from 'shared/hooks/useSupportChat';
import { VersionControl } from 'shared/types';
import { themeTokens } from '@elementary/common-ui/style/tokens';

type TokenForm = {
  token: string;
  enterpriseUrl: string | null;
};

type Props = {
  selectedVersionControl: VersionControl;
  nangoProviderId: string | undefined;
  nangoAuth: (providerId: string) => void;
  register: UseFormRegister<TokenForm>;
  errors: FieldErrors<TokenForm>;
  gitTokenError: unknown;
  nangoError: unknown;
};

const TokenAuthSection = ({
  selectedVersionControl,
  nangoProviderId,
  nangoAuth,
  register,
  errors,
  gitTokenError,
  nangoError,
}: Props) => {
  const supportChat = useSupportChat();

  return (
    <>
      <Button onClick={() => nangoProviderId && nangoAuth(nangoProviderId)}>
        Connect Elementary {selectedVersionControl} App
      </Button>
      <Divider>OR</Divider>
      <FormField errorMessage={errors.token?.message}>
        <PasswordField
          {...register('token', {
            required: requiredLabel,
          })}
          placeholder="Access token"
          variant="outlined"
          fullWidth
          size="large"
        />
      </FormField>

      {['GitHub', 'GitLab'].includes(selectedVersionControl || '') && (
        <FormField
          title="Enterprise URL"
          description="Leave empty to use the default URL"
          optional
        >
          <TextField
            {...register('enterpriseUrl')}
            placeholder="https://hostname/api/v3"
            variant="outlined"
            size="large"
          />
        </FormField>
      )}

      {gitTokenError && (
        <Alert
          severity="error"
          style={{ fontWeight: themeTokens.fontWeight.bold }}
        >
          Invalid token
        </Alert>
      )}
      {nangoError && (
        <Alert
          severity="error"
          style={{ fontWeight: themeTokens.fontWeight.bold }}
        >
          Elementary {selectedVersionControl} app failed to connect, please{' '}
          <Link onClick={supportChat.show} href="#">
            contact us
          </Link>{' '}
          for further assistance.
        </Alert>
      )}
    </>
  );
};

export default TokenAuthSection;
